var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","aria-label":_vm.$t('Show subcategories'),"data-testid":"categoryButton"}})}
var staticRenderFns = []

export { render, staticRenderFns }